<div class="flex flex-col items-stretch gap-5" *ngIf="{ mapping: service.columnMapping() } as columnMappingState">
    <div class="flex items-start justify-between gap-5">
        <div class="flex flex-col gap-2">
            <span class="font-bold" i18n>Assign Excel fields to employees</span>
            <span class="text-sm" i18n>Select fields from the Excel file to map them to the employee fields.</span>
        </div>
        <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full shrink-0 disabled:bg-transparent disabled:border-transparent"
            data-testid="smartAssistantForgetMappingBtn"
            [disabled]="!service.hasStoredColumnMapping()"
            (click)="service.forgetStoredColumnMapping()"
            i18n
        >
            Forget saved assignments
        </button>
    </div>

    <div class="grid grid-cols-3 gap-x-5">
        <div class="font-bold text-md text-iota-inh-green" i18n>Required data</div>
        <div class="col-span-2 font-bold text-md text-iota-inh-green" i18n>Link to field</div>
    </div>

    <div class="w-full flex flex-col items-stretch gap-2">
        <div
            class="w-full grid grid-cols-3 gap-x-5 items-center"
            *ngFor="let column of service.requiredColumnRows()"
            [attr.data-testid]="'columnMappingRow-' + column.key"
        >
            <div class="font-bold">{{ column.label }}</div>
            <select
                class="select select-bordered"
                [ngClass]="{ 'col-span-2': !column.isDate }"
                (change)="updateColumnMapping(column.key, $event)"
            >
                <option disabled [selected]="!columnMappingState.mapping[column.key]" i18n>please select</option>
                <option
                    *ngFor="let header of service.fileHeaders()"
                    [value]="header"
                    [selected]="header === columnMappingState.mapping[column.key]"
                >
                    {{ header }}
                </option>
            </select>
            <ng-container
                *ngIf="column.isDate"
                [ngTemplateOutlet]="dateFormatSelect"
                [ngTemplateOutletContext]="{ $implicit: column }"
            ></ng-container>
        </div>
    </div>

    <ng-container *ngIf="service.optionalColumnRows() as optionalColumns">
        <ng-container *ngIf="optionalColumns.length > 0">
            <div class="grid grid-cols-3 gap-x-5">
                <div class="font-bold text-md text-iota-inh-green" i18n>Optional data</div>
                <div class="col-span-2 font-bold text-md text-iota-inh-green" i18n>Link to field</div>
            </div>

            <div class="w-full flex flex-col items-stretch gap-2">
                <div
                    class="w-full grid grid-cols-3 gap-x-5 items-center"
                    *ngFor="let column of optionalColumns"
                    [attr.data-testid]="'columnMappingRow-' + column.key"
                >
                    <div class="font-bold">{{ column.label }}</div>
                    <select
                        class="select select-bordered"
                        [ngClass]="{ 'col-span-2': !column.isDate }"
                        (change)="updateColumnMapping(column.key, $event)"
                    >
                        <option value="" [selected]="!columnMappingState.mapping[column.key]" i18n>optional</option>
                        <option
                            *ngFor="let header of service.fileHeaders()"
                            [value]="header"
                            [selected]="header === columnMappingState.mapping[column.key]"
                        >
                            {{ header }}
                        </option>
                    </select>
                    <ng-container
                        *ngIf="column.isDate"
                        [ngTemplateOutlet]="dateFormatSelect"
                        [ngTemplateOutletContext]="{ $implicit: column }"
                    ></ng-container>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #dateFormatSelect let-column>
    <select
        class="select select-bordered"
        [attr.data-testid]="'dateFormatSelect-' + column.key"
        (change)="updateDateFormat(column.key, $event)"
    >
        <option value="" [selected]="!column.dateFormat" i18n>Detect automatically</option>
        <option *ngFor="let format of dateFormats" [value]="format" [selected]="format === column.dateFormat">
            {{ dateFormatLabels[format] }}
        </option>
    </select>
</ng-template>
